'use client';
import { Tag as TagProps } from '@osmosis/shared/types/learn';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tag } from '@osmosis/tailwind-ui/components/Tag';
interface LabelProps {
  tags: TagProps[];
  className?: string;
  cn?: string;
}

/**
 * Renders To Be Retired label.
 */
export const TBRLabel = (props: LabelProps) => {
  const { tags } = props;
  const toBeRetiredTag = tags.find(
    ({ tag }) => tag.toLowerCase() === 'to be retired',
  );

  return toBeRetiredTag ? (
    <Tag
      data-testid="learn_to_be_retired_label"
      className={`bg-blue-200 text-sm font-bold cursor-pointer ${
        props.className || ''
      }`}
      cn={props.cn}
    >
      <FormattedMessage
        defaultMessage="To be retired ⓘ"
        id="learn.header.toBeRetiredLabel"
      />
    </Tag>
  ) : null;
};
